import React from 'react';
import { TextInput, TranslatableInputs } from 'react-admin';

import RichTextInput from '../../common/inputs/RichTextInput';

import locales from '../../../services/locales';

const EventTranslatableInputs = () => (
	<TranslatableInputs locales={locales}>
		<TextInput label="Title" source="translations.title" fullWidth />
		<TextInput label="Intro" source="translations.intro" multiline rows="4" fullWidth />
		<RichTextInput label="Content" source="translations.content" />
	</TranslatableInputs>
);

export default EventTranslatableInputs;